export default {
	title: 'ui_settings',
	components: [
		{ title: 'screen_saver', component: 'screen_saver_g2' },
		{ title: 'screen_lock', component: 'screen_lock_g2' },
		{ title: 'screen_off', component: 'screen_off_g2' },
		{ title: 'dim_screen_after', component: 'dim_screen_after_g2', min_ver: '2.6.0' },
	],
};
